export enum RedirectMode {
  None = "none",
  Payment = "payment",
  Tos = "tos",
  Reactivate = "reactivate"
}
